module.exports = __webpack_public_path__ + "static/media/guidance_icon_ex.d9c0b901.png";